export default __webpack_public_path__ + "static/media/3.808b98d5.png";